import React from 'react';
import './About.css';
import { useTranslation } from 'react-i18next';

const attractions = [
  { key: 'beach',   image: 'https://www.greecetravel.com/macedonia/katerini/paralia-north-beach.jpeg?w=900&q=80', distance: '15 min' },
  { key: 'olympus', image: 'https://i.pinimg.com/originals/14/b4/e1/14b4e142ec20941f49da7d02a62eb08c.jpg?w=900&q=80', distance: '30 min' },
  { key: 'dion',    image: 'https://themountolympus.com/wp-content/uploads/2022/04/AIM40675-mount-olympus-travel-greece-pieria-ancient-dion-archaeological-park.jpg?w=900&q=80',    distance: '20 min' },
  { key: 'vergina', image: 'https://www.discovergreece.com/sites/default/files/styles/default/public/2019-12/the_royal_tombs_are_presented_within_a_grass_covered_mound_mimicking_the_original_burial_tumulus-1.jpg?itok=iT9EaRix?w=900&q=80', distance: '1h 15min' },
  { key: 'parks',   image: 'https://images.unsplash.com/photo-1448375240586-882707db888b?w=900&q=80', distance: 'nearby' },
];

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="about-page">
      {/* Hero */}
      <section className="about-hero">
        <div className="about-hero-content">
          <span className="about-hero-eyebrow">{t('nav.about')}</span>
          <h1 className="about-hero-title">{t('about.title')}</h1>
          <p className="about-hero-tagline">{t('about.intro')}</p>
        </div>
      </section>

      {/* About info section */}
      <section className="about-info-section">
        <div className="about-info-text">
          <p>{t('about.description')}</p>
          <p>{t('about.description2')}</p>
          <p>{t('about.description3')}</p>
        </div>
        <div className="about-info-visual">
          <img
            src="https://ik.imagekit.io/kimchel/Sevasti-title/homeImage1.jpg"
            alt="Sevasti Country House"
          />
        </div>
      </section>

      {/* Attractions */}
      <section className="about-attractions">
        <div className="attractions-heading">
          <span className="attractions-label">{t('about.attractions.title')}</span>
        </div>

        {attractions.map((attr, index) => (
          <div
            key={attr.key}
            className={`attraction-row${index % 2 === 1 ? ' reverse' : ''}`}
          >
            <div className="attraction-img-wrap">
              <img src={attr.image} alt={t(`about.attractions.${attr.key}.title`)} />
            </div>
            <div className="attraction-body">
              <span className="attraction-dist">{attr.distance}</span>
              <h2 className="attraction-title">{t(`about.attractions.${attr.key}.title`)}</h2>
              <p className="attraction-desc">{t(`about.attractions.${attr.key}.description`)}</p>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default About;
